import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ClientList from './ClientList';
import ClientForm from './ClientForm';
import ClientsForm from './ClientsForm';

const ClientRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<ClientList />} />
      <Route path="/new" element={<ClientsForm />} />
      <Route path="/edit/:id" element={<ClientsForm />} />

      <Route path="/view/:id" element={<ClientForm />} />
    </Routes>
  );
};

export default ClientRoutes; 